import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import { authenticatedHeadersHash } from "views_shared/app/javascript/scripts/authentication";
import ImageCropped from "views_shared/app/javascript/components/ImageCropped";

function MediaProfileResult({ gid, setResultTitle, setResultUrl }) {
  const match = gid.match(/gid:\/\/qwoted\/([^/]+)\/(\d+)/);
  const mediaProfileId = match ? match[2] : null;
  const [mediaProfile, setMediaProfile] = useState(null);

  useEffect(() => {
    const query = `${globalThis.Qwoted.SUPABASE_API_EXTERNAL_URL}/rest/v1/media_profiles?profile_id=eq.${mediaProfileId}`;
    fetch(query, {
      method: "GET",
      headers: new Headers(authenticatedHeadersHash()),
    })
      .then((response) => {
        return response.json();
      })
      .then((responseJson) => {
        if (responseJson[0]) {
          const mp = responseJson[0];
          setMediaProfile(mp);
          setResultTitle(`Media profile: ${mp.name}`);
          setResultUrl(`/media_profiles/${mp.slug}`);
        }
      });
  }, [mediaProfileId, setResultTitle, setResultUrl]);

  if (!mediaProfile) {
    return null;
  }

  return (
    <div>
      <a href={`/media_profiles/${mediaProfile.slug}`}>
        <ImageCropped wrapperClasses="me-2" src={mediaProfile.profile_image_url} alt={mediaProfile.name} size={45} />
        {mediaProfile.title_at_workplace}
      </a>
    </div>
  );
}

MediaProfileResult.propTypes = {
  gid: PropTypes.string.isRequired,
};
export default MediaProfileResult;
